import api from "./API";

// OKRs (Objectives & Key Results) - modulo opcional, atras do recurso "okrs".

export const fetchCiclos = (idWorkspace) =>
  api.get("/okr/ciclos", { params: { idWorkspace } });

export const criarCiclo = (payload) => api.post("/okr/ciclos", payload);

export const analisarCicloComIA = (idCiclo) => api.post(`/okr/ciclos/${idCiclo}/analise-ia`);

export const fetchAreas = (idWorkspace) =>
  api.get("/okr/areas", { params: { idWorkspace } });

export const criarArea = (payload) => api.post("/okr/areas", payload);

export const fetchObjetivos = (idCiclo) =>
  api.get("/okr/objetivos", { params: { idCiclo } });

export const criarObjetivo = (payload) => api.post("/okr/objetivos", payload);

export const atualizarObjetivo = (idObjetivo, payload) =>
  api.put(`/okr/objetivos/${idObjetivo}`, payload);

export const removerObjetivo = (idObjetivo) => api.delete(`/okr/objetivos/${idObjetivo}`);

export const fetchResultadosChave = (idObjetivo) =>
  api.get("/okr/resultados-chave", { params: { idObjetivo } });

export const criarResultadoChave = (payload) => api.post("/okr/resultados-chave", payload);

export const atualizarResultadoChave = (idResultadoChave, payload) =>
  api.put(`/okr/resultados-chave/${idResultadoChave}`, payload);

export const definirEstrategiaAgregacao = (idResultadoChave, estrategiaAgregacao) =>
  api.put(`/okr/resultados-chave/${idResultadoChave}/estrategia-agregacao`, { estrategiaAgregacao });

export const definirNota = (idResultadoChave, notaFinal) =>
  api.put(`/okr/resultados-chave/${idResultadoChave}/nota`, { notaFinal });

export const removerResultadoChave = (idResultadoChave) =>
  api.delete(`/okr/resultados-chave/${idResultadoChave}`);

export const registrarCheckin = (payload) => api.post("/okr/checkins", payload);

export const fetchIniciativas = (idResultadoChave) =>
  api.get(`/okr/resultados-chave/${idResultadoChave}/iniciativas`);

export const criarIniciativa = (idResultadoChave, payload) =>
  api.post(`/okr/resultados-chave/${idResultadoChave}/iniciativas`, payload);

export const vincularIniciativa = (idResultadoChave, idTarefa) =>
  api.post(`/okr/resultados-chave/${idResultadoChave}/iniciativas/vincular`, { idTarefa });

export const removerIniciativa = (idIniciativa) =>
  api.delete(`/okr/iniciativas/${idIniciativa}`);

export const ESTRATEGIAS_AGREGACAO = [
  { valor: "soma", label: "Soma" },
  { valor: "media", label: "Media" },
  { valor: "ultimo", label: "Ultimo valor" },
  { valor: "maximo", label: "Maximo" },
  { valor: "minimo", label: "Minimo" },
];

export const TIPOS_METRICA = [
  { valor: "numero", label: "Numero" },
  { valor: "percentual", label: "Percentual" },
  { valor: "moeda", label: "Moeda" },
  { valor: "booleano", label: "Booleano" },
];
